import React, { useState } from "react";
import { Layout, Button, Space, Typography } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../../features/auth/model/AuthContext";
import { PATHS } from "../router/paths";
import AccountMenu from "./AccountMenu";

const { Header } = Layout;
const { Title } = Typography;

type TopHeaderProps = {
  title?: React.ReactNode;
  onShowSidebar: () => void;
};

const TopHeader: React.FC<TopHeaderProps> = ({ title, onShowSidebar }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);
  const username = user?.display_name || user?.email || "ユーザー";

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      await logout();
      navigate(PATHS.AUTH.LOGIN, { replace: true });
    } finally {
      setLoggingOut(false);
    }
  };

  return (
    <Header
      style={{
        background: "#fff",
        padding: "0 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #f0f0f0",
        height: 56,
      }}
    >
      {/* LEFT */}
      <Space>
        <Button
          type="text"
          shape="circle"
          icon={<MenuOutlined />}
          onClick={onShowSidebar}
          style={{
            background: "#f5f5f5",
            width: 40,
            height: 40,
          }}
        />
        <Title level={5} style={{ margin: 0 }}>
          {title}
        </Title>
      </Space>

      {/* CENTER */}

      {/* RIGHT */}
      <Space size={8} style={{ flexShrink: 0 }}>
        <span
          style={{
            padding: "4px 8px",
            borderRadius: 999,
            background: "#fff1f0",
            color: "#cf1322",
            fontSize: 18,
            fontWeight: 600,
            whiteSpace: "nowrap",
          }}
        >
          デモ用環境
        </span>
        <AccountMenu
          username={username}
          avatarUrl={user?.avatar_url}
          actions={[
            {
              key: "logout",
              label: "ログアウト",
              icon: <span className="material-symbols-outlined">logout</span>,
              danger: true,
              loading: loggingOut,
              onClick: handleLogout,
            },
          ]}
        />
      </Space>
    </Header>
  );
};

export default TopHeader;
